import { createSelector } from 'reselect';
import { STANDARD_DATASOURCES } from '../../../common/support/eo_mapping';
import { COLUMN_TYPE, buildColumn } from '../../../common/support/utils';
import type { IColumn } from '../../../common/types/IColumn';
import type { ColumnOptions, GetColumnKeys, GetColumnOptions } from './createColumnsSelector.types';

export const getDatasourceColumns = (datasourcesKeys: string[], options?: ColumnOptions): IColumn[] => {
  const columnKeys = datasourcesKeys.filter((datasourceKey) => !STANDARD_DATASOURCES[datasourceKey]);

  return columnKeys.map((key) => buildColumn({ type: COLUMN_TYPE.DATASOURCE, key, ...options }));
};

export const createDatasourceColumnsSelector = (
  getDatasourceKeys: GetColumnKeys,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(getDatasourceKeys, getColumnOptions, getDatasourceColumns);
};
